import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=2e8bc0ea&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"
import style0 from "./Balance.vue?vue&type=style&index=0&id=2e8bc0ea&prod&scoped=true&lang=css"
import style1 from "./Balance.vue?vue&type=style&index=1&id=2e8bc0ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8bc0ea",
  null
  
)

export default component.exports